import ContentContainer from './content/ContentContainer';
import './App.css';
import './style/GlobalVariables.css';
import { BrowserRouter } from 'react-router-dom';
import '../i18n';
import '../validations/index';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { useEffect } from 'react';

function App() {

    useEffect(() => {
        const handleWheel = (e) => {
            const active = document.activeElement;
            if (active && active.type === 'number') {
                active.blur();
            }
        };
        window.addEventListener('wheel', handleWheel, { passive: true });
        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <div className={'mainApp'}>
                    <ContentContainer />
                    {/*<FooterContainer // TODO: remove? />*/}
                </div>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
